import React, { Component } from 'react';
import { connect } from 'react-redux'; 
import { withTranslation } from 'react-i18next'; 
import Button from 'screens/components/basic/Button';
import {
    postSpringbigRewardDiscount
} from 'actions/EntityActions';
// Basic Components
import DialogInput from 'screens/components/advanced/DialogInput';
import DialogHeader from 'screens/components/basic/DialogHeader'

const customContentStyle = {
    width: '75%',
    maxWidth: 'none'
};

class POSSpringbigRewards extends Component {

    constructor(props, context) {
        super(props, context);
        this.state = {
            rewardDetailDialogOpen: false,
            selectedReward: null
        }
    }

    checkDetails = (reward) => {

        this.setState({
            rewardDetailDialogOpen: true,
            selectedReward: reward
        });
    }

    addToOrder = (reward) => {
        const deviceData = JSON.parse(localStorage.getItem(this.props.deviceKeyName));

        let percentage = 0;
        let amount = 0;

        if (reward.discount_type && reward.discount_type == '%' && reward.discount_amount) {
            percentage = reward.discount_amount
        }
        else if (reward.discount_type && reward.discount_type == '$' && reward.discount_amount) {
            amount = reward.discount_amount
        }

        let model = {
            Id: this.props.order ? this.props.order.id : 0, BranchId: this.props.branchId,
            DeviceId: deviceData.id, Percentage: percentage,
            Amount: amount, Notes: this.props.t('pos.springbigRewards.bigReward'),
            RewardId: reward.id ? reward.id : 0, PatientId: this.props.order ? this.props.order.patientId : 0
        };

        this.props.postSpringbigRewardDiscount(model);
        this.closeRewardDetailDialog();
        this.closeRewards();
        console.log(reward.id + " " + this.props.t('pos.springbigRewards.rewardAdded'))
    }

    closeRewardDetailDialog = () => {
        this.setState({ rewardDetailDialogOpen: false });
    }

    closeRewards = () => {
        this.props.onClose();
    }

    render() {
        const { t } = this.props; 
        const rewards = this.props.rewards.filter(x => x.active).filter(x => this.props.balance >= x.item_value); // active and enough points to redeem
        let selectedReward = this.state.selectedReward;

        return (
            <div>
                <DialogInput
                    open={this.props.open}
                >
                    {!rewards ?
                        <div className="row m-0">
                            <div className="alert alert-warning">
                                {t('pos.springbigRewards.noRewardFound')}
                            </div>
                        </div> :
                        <div>
                            {this.props.balance ? <div><h1>{t('pos.springbigRewards.springbigRewards')}</h1><h1>{this.props.firstName ? this.props.firstName : " "} {this.props.lastName ? this.props.lastName : " "} {t('pos.springbigRewards.has')} {this.props.balance ? this.props.balance : ""} {t('pos.discountDialog.points')}</h1></div> : <h1>{t('pos.springbigRewards.couldnotRetrievePoints')} {this.props.firstName ? this.props.firstName : " "} {this.props.lastName ? this.props.lastName : " "}</h1>}
                            <div className="row m-0">
                                {
                                    (rewards !== undefined && rewards !== null) &&
                                    rewards.map((reward, index) => {
                                        let redeemValid = this.props.order.subTotal <= 0.0 || !reward.discount_amount || !reward.discount_type || (reward.discount_type && reward.discount_type == "$" && reward.discount_amount && reward.discount_amount > this.props.order.subTotal);
                                        return (
                                            <div key={index} className="item-online-order">
                                                <div className="col-lg-4 col-sm-4 col-xs-4 col-md-4">
                                                    <div>
                                                        {reward.name}
                                                    </div>
                                                </div>
                                                <div className="col-lg-4 col-sm-4 col-xs-4 col-md-4 btn-start">
                                                    <Button
                                                        name="finishButton"
                                                        label={t('common.viewDetails')}
                                                        className="pull-right btn-finish"
                                                        primary={true}
                                                        onTouchTap={() => this.checkDetails(reward)}
                                                    />
                                                </div>
                                                <div className="col-lg-4 col-sm-4 col-xs-4 col-md-4 btn-start">
                                                    <Button
                                                        name="finishButton"
                                                        label={t('common.redeem')}
                                                        className="pull-right btn-load-create-order"
                                                        primary={true}
                                                        onTouchTap={() => this.addToOrder(reward)}
                                                        disabled={redeemValid}
                                                    />
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </div>
                        </div>}
                    <Button name="buttonCancel"
                        type="Button"
                        className="corner_X"
                        label=""
                        onTouchTap={() => this.closeRewards()}
                    />
                </DialogInput>
                <DialogInput
                    title={<DialogHeader text={selectedReward ? selectedReward.name : ""} classicClass="posDialogClassic"/>}
                    modal={true}
                    open={this.state.rewardDetailDialogOpen}
                    autoScrollBodyContent={true}
                    className="online-orders-line-dialog checkIn_list"
                    handleClose={() => this.closeRewardDetailDialog()}
                    contentStyle={customContentStyle}
                >
                    {
                        selectedReward ?
                            <div className='text-center'>
                                {selectedReward.item_value && <h3>{t('pos.printReceipt.points')}: {selectedReward.item_value}</h3>}
                                {!selectedReward.discount_amount || !selectedReward.discount_type ? <h3>{t('pos.springbigRewards.discount')}: {t('pos.springbigRewards.unspecifiedLower')}</h3> : (selectedReward.discount_type && selectedReward.discount_type == "%" ? <h3>{t('pos.springbigRewards.discount')}: {selectedReward.discount_amount}%</h3> : <h3>{t('pos.springbigRewards.discount')}: ${selectedReward.discount_amount}</h3>)}
                                ----------------------------------------------------------------
                                {selectedReward.description && <p>{selectedReward.description}</p>}
                                {selectedReward.discount_type == "$" && selectedReward.discount_amount > this.props.order.subTotal && <p className="danger">{t('pos.springbigRewards.subTotalAtLeastDiscountAmount')}</p>}
                            </div>
                            : ""
                    }

                    <Button name="buttonCancel"
                        type="Button"
                        className="corner_X"
                        label=""
                        onTouchTap={() => this.closeRewardDetailDialog()}
                    />
                </DialogInput>
            </div>
        );
    }
}



function mapStateToProps(state) {
    return {
        branchId: state.common.branchId,
        rewards: state.entity.springBigRewards || [],
        firstName: state.entity.posOrder ? state.entity.posOrder.patientFirstName : '',
        lastName: state.entity.posOrder ? state.entity.posOrder.patientLastName : '',
        balance: state.entity.springBigMemberPoints ? state.entity.springBigMemberPoints.balance : '',
        id: state.entity.springBigMemberPoints ? state.entity.springBigMemberPoints.id : '',
        order: state.entity.posOrder || {},
        deviceKeyName: state.common.applicationSettings.deviceKeyName
    }
}

function mapDispatchToProps(dispatch) {
    return {
        postSpringbigRewardDiscount: (model) => dispatch(postSpringbigRewardDiscount(model))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withTranslation()(POSSpringbigRewards))